/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from "react";
import { requestHeader } from "../../services/api/auth/useUser";
import { useCanDownload } from "../../services/api/auth/permissions";
import IndicateurAnalyseButton from "../../core/components/IndicateurAnalyseButton";
import DashboardMenu from "../../core/components/ModalAnalyse";
import { useNavigate, useLocation } from "react-router-dom";
import { UserGroupIcon } from "@heroicons/react/24/solid";
import { API_URL } from "../../services/api/axios";
import { getFromApiFunction } from "../../services/api/apiFunctions";
import { InterventionType } from "../../models/InterventionModel";
import SelectComponent from "./SelectComponent";
import { Tooltip } from "antd";
import { toast } from "react-hot-toast";
import Departement, { Commune } from "../../models/Departement_model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

export function useLocalStorageState(key: string, defaultValue: any = undefined) {
  const [state, setState] = useState(() => {
    let value;
    const keys = key.split(".");
    let keyValue: any = { [keys[0]]: localStorage.getItem(keys[0]) };
    try {
      keys.forEach((k) => {
        keyValue = keyValue[k];
        if (keyValue) {
          value = JSON.parse(keyValue) || defaultValue;
        } else {
          value = defaultValue;
        }
        keyValue = value;
      });
    } catch (error) {
      value = keyValue || defaultValue;
    }

    return value;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
}

function DownloadsModal(props: any) {
  const { openDownloads, setOpenDownloads } = props;
  const [interventions, setInterventions] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [selectedIndic, setSelectedIndic] = useState();

  const [department, setDepartment] = useState();
  const [commune, setCommune] = useState();
  const [communes, setCommunes] = useState<any>([]);
  const [departments, setDepartments] = useState<any>([]);

  useEffect(() => {
    Departement.fetchData().then((response: any) => {
      setDepartments(Departement.toSelectOption(response.data));
    });
  }, []);

  useEffect(() => {
    if (!department) return;
    Commune.fetchData(new URLSearchParams([["departement", department]])).then(
      (response: any) => {
        setCommunes(Commune.toSelectOption(response.data));
      },
    );
  }, [department]);

  useEffect(() => {
    InterventionType.fetchData().then((response: any) => {
      setInterventions(response.data.results);
    });
    getFromApiFunction("indicators/").then((response) => {
      setIndicators(response.data.results);
    });
  }, []);

  return (
    // React fragment
    <>
      <div
        className={`${
          openDownloads ? "" : "hidden"
        } lc-modal fixed left-1/2 top-1/2 -translate-x-2/4 -translate-y-2/4 max-w-[350px] sm:max-w-full sm:min-w-[400px] bg-white p-5 z-[99999] transition-pacofide`}
        data-lc-target="download"
      >
        <span
          className="lc-modal-icon-cross absolute right-3 top-3 flex items-center justify-center h-[30px] w-[30px] hover:bg-gray-200 text-slate-500 text-2xl z-[2] cursor-pointer rounded-full transition-pacofide"
          data-lc-target="#download"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            style={{ fill: "currentColor" }}
            onClick={() => setOpenDownloads(false)}
          >
            <path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path>
          </svg>
        </span>

        <div className="mt-14 space-y-12 max-h-[564px] overflow-auto">
          <div className="relative">
            <h3 className="text-xl font-medium text-slate-500">
              Interventions & indicateurs
            </h3>
            <div>
              <div className="block w-full overflow-x-auto rounded-md">
                <table className="w-full mt-6 border border-collapse border-slate-400">
                  <tbody>
                    <tr className="text-xs text-slate-500 odd:bg-white even:bg-slate-50">
                      <td className="px-3 py-2.5 font-medium border border-slate-300 whitespace-nowrap">
                        <SelectComponent
                          options={
                            // Merge axisYears and years unique values
                            indicators
                              .filter((indic: any) => !indic.synoptic_only)
                              .map((indic: any) => ({
                                label: (
                                  <Tooltip zIndex={9999999} title={indic.name}>
                                    {indic.code}
                                  </Tooltip>
                                ),
                                value: indic.id,
                              }))
                          }
                          onChange={setSelectedIndic}
                          customPlaceHolder="Indicateur"
                          className="w-full"
                          value={selectedIndic}
                          // disabled={fetchingData}
                        />
                      </td>
                      <td className="px-3 py-2.5 border border-slate-300">
                        <div className="flex items-center justify-center">
                          <button
                            type="button"
                            className="bg-blue-500 hover:bg-blue-600 shadow-md text-white text-[12px] font-medium px-4 py-1.5 rounded-md transition-pacofide"
                            onClick={() =>
                              downloadFile(
                                `indicators/${selectedIndic}/values/`,
                                "Indicateurs.xlsx",
                              )
                            }
                          >
                            Télécharger
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr className="text-xs text-slate-500 odd:bg-white even:bg-slate-50">
                      <td className="px-3 py-2.5 font-medium border border-slate-300 whitespace-nowrap">
                        <SelectComponent
                          options={departments}
                          onChange={(value) => {
                            setDepartment(value);
                            setCommune(undefined);
                          }}
                          customPlaceHolder="Département"
                          className="w-full"
                          value={department}
                          // disabled={fetchingData}
                        />
                      </td>
                      <td className="px-3 py-2.5 border border-slate-300">
                        <SelectComponent
                          options={communes}
                          onChange={setCommune}
                          customPlaceHolder="Commune"
                          className="w-full"
                          value={commune}
                        />
                      </td>
                    </tr>
                    {commune && (
                      <>
                        {interventions
                          .filter(
                            (intervention: any) => intervention.geom_type === "Point",
                          )
                          .map((intervention: any, index: number) => (
                            <tr
                              className="text-xs text-slate-500 odd:bg-white even:bg-slate-50"
                              key={index}
                            >
                              <td className="px-3 py-2.5 font-medium border border-slate-300 whitespace-nowrap">
                                {intervention.name}
                              </td>
                              <td className="px-3 py-2.5 border border-slate-300">
                                <div className="flex items-center justify-center">
                                  <button
                                    type="button"
                                    className="bg-blue-500 hover:bg-blue-600 shadow-md text-white text-[12px] font-medium px-4 py-1.5 rounded-md transition-pacofide"
                                    onClick={() =>
                                      downloadFile(
                                        `interventions/downloads/?intervention_type=${intervention.id}&commune=${commune}`,
                                        `Interventions-${intervention.name}-${commune}.xlsx`,
                                      )
                                    }
                                  >
                                    Télécharger
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${
          openDownloads ? "" : "hidden"
        } lc-modal-overlay fixed left-0 top-0 h-full w-full bg-black/50 z-[9999] transition-pacofide`}
        data-lc-target="download"
        onClick={() => setOpenDownloads(false)}
      ></div>
    </>
  );
}

const excel_accept =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export async function downloadFile(
  endPoint: string,
  fileName: string,
  accept = excel_accept,
  callback: any = null,
) {
  // Getting me using axios ensure that we always get a
  // valid token to proceed to download

  const headers: any = requestHeader();
  if (accept !== "") headers.Accept = `${accept},application/json`;
  // Build url with params
  const url = `${API_URL}/${endPoint}`;
  fetch(url, { headers })
    .then((result) => {
      if (callback) callback(true);
      if (result.status == 401) {
        getFromApiFunction("users/me").then(() => {
          downloadFile(endPoint, fileName, accept, callback);
        });
      }
      if (!result.ok) {
        throw Error(result.statusText);
      }
      if (result.status == 204) {
        toast.error("Aucune donnée trouvée pour cette intervention.");
        return;
      }
      const match = result.headers
        .get("Content-Disposition")
        ?.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n\r]*)["']?/i);
      localStorage.setItem(url, match ? decodeURIComponent(match[1]) : "");
      return result.blob();
    })
    .then((blob) => {
      if (!blob) {
        return;
      }
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.target = "_blank";
      link.setAttribute("download", localStorage.getItem(url) || fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
}

export default function Navbar(props: any) {
  const { setSelectedIntervention, publicIsAnalyzeOpen, publicIsAnalyzeOpenSetter } =
    props;

  const [openDownloads, setOpenDownloads] = useState(false);
  const [isAnalyzeOpen, setIsAnalyzeOpen] = useState(false);
  const [filiereVisible, setFiliereVisible] = useState(false);
  const canDownloadFiles = useCanDownload();

  const [pending, setPending] = useState(false);

  const setRequestCompleted = (value: boolean) => {
    setPending(value);
  };

  const filieresRef = useRef<any>(null);
  const mobileMenu = useRef<any>(null);

  const [filiereComponent, setFiliereComponent] = useState<any>(null);

  const navigate = useNavigate();

  const location = useLocation();

  const closeAnalyse = () => {
    setIsAnalyzeOpen(false);
    // setIsAnalyseOpen(false);
  };
  const openAnalyse = () => {
    // setSelectedFiliere(filiere);
    setIsAnalyzeOpen(true);
    switchMobileMenu();
  };

  function selectFiliere(event: any, value: any) {
    setFiliereVisible(false);
  }

  useEffect(() => {
    if (!filieresRef.current) return;
    if (filiereVisible) {
      filieresRef.current.classList.add("group-hover:grid");
    } else {
      filieresRef.current?.classList.remove("group-hover:grid");
    }
  }, [filiereVisible]);

  useEffect(() => {
    setIsAnalyzeOpen(publicIsAnalyzeOpen);
  }, [publicIsAnalyzeOpen]);

  useEffect(() => {
    publicIsAnalyzeOpenSetter(isAnalyzeOpen);
  }, [isAnalyzeOpen]);

  const switchMobileMenu = function () {
    if (!mobileMenu.current) return;
    if (mobileMenu.current.classList.contains("group-hover:grid")) {
      mobileMenu.current.classList.remove("group-hover:grid");
    } else {
      mobileMenu.current.classList.add("group-hover:grid");
    }
  };

  const navigateAndHide = function (url: string) {
    switchMobileMenu();
    navigate(url);
  };

  const logos = {
    home: <FontAwesomeIcon icon={faHome} style={{ fontSize: "24px" }} />,
    mapping: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        style={{ fill: "currentColor" }}
      >
        <path d="m21.447 6.105-6-3a1 1 0 0 0-.895 0L9 5.882 3.447 3.105A1 1 0 0 0 2 4v13c0 .379.214.725.553.895l6 3a1 1 0 0 0 .895 0L15 18.118l5.553 2.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851V7c0-.379-.214-.725-.553-.895zM10 7.618l4-2v10.764l-4 2V7.618zm-6-2 4 2v10.764l-4-2V5.618zm16 12.764-4-2V5.618l4 2v10.764z"></path>
      </svg>
    ),
    dashboard: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        style={{ fill: "currentColor" }}
      >
        <path d="M3 3v17a1 1 0 0 0 1 1h17v-2H5V3H3z"></path>
        <path d="M15.293 14.707a.999.999 0 0 0 1.414 0l5-5-1.414-1.414L16 12.586l-2.293-2.293a.999.999 0 0 0-1.414 0l-5 5 1.414 1.414L13 12.414l2.293 2.293z"></path>
      </svg>
    ),
    library: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        style={{ fill: "currentColor" }}
      >
        <path d="M19 2.01H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.998 5 19.815 5 19.01c0-.101.009-.191.024-.273.112-.575.583-.717.987-.727H20c.018 0 .031-.009.049-.01H21V4.01c0-1.103-.897-2-2-2zm0 14H5v-11c0-.806.55-.988 1-1h7v7l2-1 2 1v-7h2v12z"></path>
      </svg>
    ),
    maps: (
      <svg
        fill="#ffffff"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        height="24"
        width="24"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <g>
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M12,14c-0.1,0-0.3,0-0.4-0.1l-11-5C0.2,8.7,0,8.4,0,8s0.2-0.7,0.6-0.9l11-5c0.3-0.1,0.6-0.1,0.8,0l11,5 C23.8,7.3,24,7.6,24,8s-0.2,0.7-0.6,0.9l-11,5C12.3,14,12.1,14,12,14z M3.4,8l8.6,3.9L20.6,8L12,4.1L3.4,8z"></path>{" "}
              </g>{" "}
            </g>{" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M12,22c-0.1,0-0.3,0-0.4-0.1l-11-5C0.2,16.7,0,16.4,0,16s0.2-0.7,0.6-0.9l4.4-2c0.5-0.2,1.1,0,1.3,0.5 c0.2,0.5,0,1.1-0.5,1.3L3.4,16l8.6,3.9l8.6-3.9l-2.4-1.1c-0.5-0.2-0.7-0.8-0.5-1.3c0.2-0.5,0.8-0.7,1.3-0.5l4.4,2 c0.4,0.2,0.6,0.5,0.6,0.9s-0.2,0.7-0.6,0.9l-11,5C12.3,22,12.1,22,12,22z"></path>{" "}
              </g>{" "}
            </g>{" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M12,18c-0.1,0-0.3,0-0.4-0.1l-11-5C0.2,12.7,0,12.4,0,12s0.2-0.7,0.6-0.9l4.4-2c0.5-0.2,1.1,0,1.3,0.5 c0.2,0.5,0,1.1-0.5,1.3L3.4,12l8.6,3.9l8.6-3.9l-2.4-1.1c-0.5-0.2-0.7-0.8-0.5-1.3c0.2-0.5,0.8-0.7,1.3-0.5l4.4,2 c0.4,0.2,0.6,0.5,0.6,0.9s-0.2,0.7-0.6,0.9l-11,5C12.3,18,12.1,18,12,18z"></path>{" "}
              </g>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
    ),

    database: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        style={{ fill: "currentColor" }}
      >
        <path d="M20 17V7c0-2.168-3.663-4-8-4S4 4.832 4 7v10c0 2.168 3.663 4 8 4s8-1.832 8-4zM12 5c3.691 0 5.931 1.507 6 1.994C17.931 7.493 15.691 9 12 9S6.069 7.493 6 7.006C6.069 6.507 8.309 5 12 5zM6 9.607C7.479 10.454 9.637 11 12 11s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2V9.607zM6 17v-2.393C7.479 15.454 9.637 16 12 16s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2z"></path>
      </svg>
    ),
    actors: <UserGroupIcon className="w-6 h-6 text-white" />,
  };

  return (
    <>
      <div className={`${location.pathname === "/" ? "hidden" : ""}`}>
        <nav className="fixed z-[9999] w-full bg-amber-600">
          <div className="max-w-[1400px] mx-auto my-0 px-4 md:px-10 flex items-center justify-between">
            {/* <span className="display-none md:display-block" style={{ width: "200px" }}>
            <img
              className=""
              src="./assets/logo-p2ae.png" style={{ marginTop: "-27%" }} />
            </span> */}
            {/* <div className="flex items-center space-x-4 text-white text-base md:text-xl">
              Filière
              <div
                className="transition-pacofide border-b-[3px] border-transparent hover:border-white group relative"
                onMouseEnter={() => {
                  setFiliereVisible(true);
                }}
              >
                <a
                  href="#"
                  className="flex items-center px-2 py-4 space-x-2 text-base font-normal text-white sm:px-5 sm:py-5 transition-pacofide"
                  onClick={() => {
                    setFiliereVisible(true);
                  }}
                >
                  {selectedFiliere !== "" ? (
                    filiereComponent
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      style={{ fill: "currentColor" }}
                    >
                      <path d="M3 3v17a1 1 0 0 0 1 1h17v-2H5V3H3z"></path>
                      <path d="M15.293 14.707a.999.999 0 0 0 1.414 0l5-5-1.414-1.414L16 12.586l-2.293-2.293a.999.999 0 0 0-1.414 0l-5 5 1.414 1.414L13 12.414l2.293 2.293z"></path>
                    </svg>
                  )}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    style={{ fill: "rgba(255, 255, 255, 1)" }}
                    className="pacofide-nav-icon transition-pacofide group-hover:rotate-180"
                  >
                    <path d="M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"></path>
                  </svg>
                </a>
                <ul
                  className="pacofide-nav-dropdown-menu group-hover:pointer-events-auto group-hover:top-[59px] group-hover:sm:top-[67px] z-[9999999]"
                  style={{ width: "200px" }}
                  ref={filieresRef}
                >
                  {defaultFilieres.map((filiere: Filiere, index: number) => {
                    return (
                      <li
                        key={`${filiere.id}-${index}`}
                        className="pacofide-nav-dropdown-item"
                        onClick={(event) => selectFiliere(event, filiere.value)}
                      >
                        <a
                          // href={}
                          className="flex flex-col items-center justify-center p-2 space-x-2 rounded-md hover:bg-gray-300 transition-pacofide"
                        >
                          <span className="flex items-center justify-center bg-gray-100 rounded-full w-11 h-11">
                            {<filiere.component />}
                          </span>
                          <span className="pacofide-nav-dropdown-link-inner">
                            {filiere.name}
                          </span>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div> */}
            <a href="#" className="navbar-brand">
              P2AE
            </a>

            <div className="flex items-center mr-8">
              {/* Navbar to be displayed on large screen */}
              <ul className="items-center hidden md:flex">
                <li className="transition-pacofide border-b-[3px] border-transparent hover:border-white">
                  <a
                    className="flex items-center px-2 py-4 space-x-4 text-base font-normal text-white sm:px-5 sm:py-5 transition-pacofide"
                    onClick={() => navigate("/")}
                    title="Accueil"
                  >
                    {logos.home}
                  </a>
                </li>
                <li className="transition-pacofide border-b-[3px] border-transparent hover:border-white">
                  <a
                    className="flex items-center px-2 py-4 space-x-4 text-base font-normal text-white sm:px-5 sm:py-5 transition-pacofide"
                    onClick={() => navigate("mapping")}
                    title="Mapping"
                  >
                    {logos.mapping}
                  </a>
                </li>
                <li className="transition-pacofide border-b-[3px] border-transparent hover:border-white">
                  <a
                    className="flex items-center px-2 py-4 space-x-4 text-base font-normal text-white sm:px-5 sm:py-5 transition-pacofide"
                    onClick={() => openAnalyse()}
                    title="Tableau de Bord"
                  >
                    {logos.dashboard}
                  </a>
                </li>
                {canDownloadFiles && (
                  <li className="transition-pacofide border-b-[3px] border-transparent hover:border-white">
                    <a
                      id="download"
                      className="flex items-center px-2 py-4 space-x-4 text-base font-normal text-white sm:px-5 sm:py-5 lc-modal-show transition-pacofide"
                      onClick={() => setOpenDownloads(true)}
                      title="Base de données"
                    >
                      {logos.database}
                    </a>
                  </li>
                )}
                <li className="transition-pacofide border-b-[3px] border-transparent hover:border-white">
                  <a
                    href="#"
                    className="flex items-center px-2 py-4 space-x-4 text-base font-normal text-white sm:px-5 sm:py-5 transition-pacofide"
                    onClick={() => navigate("reports")}
                    title="Bibliothèque"
                  >
                    {logos.library}
                  </a>
                </li>
                <li className="transition-pacofide border-b-[3px] border-transparent hover:border-white">
                  <a
                    href="#"
                    className="flex items-center px-2 py-4 space-x-4 text-base font-normal text-white sm:px-5 sm:py-5 transition-pacofide"
                    onClick={() => navigate("maplibrary")}
                    title="Médiathèque"
                  >
                    {logos.maps}
                  </a>
                </li>
                <li className="transition-pacofide border-b-[3px] border-transparent hover:border-white">
                  <a
                    href="#"
                    className="flex items-center px-2 py-4 space-x-4 text-base font-normal text-white sm:px-5 sm:py-5 transition-pacofide"
                    onClick={() => navigate("actors")}
                    title="Acteurs"
                  >
                    {logos.actors}
                  </a>
                </li>
              </ul>

              {/* Navigation on small screen */}
              <div className="block md:hidden transition-pacofide border-b-[3px] border-transparent hover:border-white group">
                <a
                  href="#"
                  className="flex items-center px-2 py-4 space-x-4 text-base font-normal text-white sm:px-5 sm:py-5 transition-pacofide"
                  onClick={() => {
                    switchMobileMenu();
                  }}
                  onPointerLeave={() =>
                    mobileMenu.current?.classList.remove("group-hover:grid")
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    style={{ fill: "currentColor" }}
                  >
                    <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"></path>
                  </svg>
                </a>
                <ul
                  ref={mobileMenu}
                  className="pacofide-nav-dropdown-menu group-hover:pointer-events-auto group-hover:top-[59px] group-hover:sm:top-[67px] sm:left-[72%]"
                >
                  <li className="pacofide-nav-dropdown-item">
                    <a
                      onClick={() => navigateAndHide("/")}
                      className="flex flex-col items-center justify-center p-2 space-x-2 rounded-md hover:bg-gray-300 transition-pacofide"
                    >
                      <span className="flex items-center justify-center bg-gray-100 rounded-full w-11 h-11">
                        {logos.home}
                      </span>
                      <span className="pacofide-nav-dropdown-link-inner">Accueil</span>
                    </a>
                  </li>
                  <li className="pacofide-nav-dropdown-item">
                    <a
                      onClick={() => navigateAndHide("mapping")}
                      className="flex flex-col items-center justify-center p-2 space-x-2 rounded-md hover:bg-gray-300 transition-pacofide"
                    >
                      {logos.mapping}
                      <span className="pacofide-nav-dropdown-link-inner">Mapping</span>
                    </a>
                  </li>
                  <li className="pacofide-nav-dropdown-item">
                    <a
                      onClick={() => openAnalyse()}
                      className="flex flex-col items-center justify-center p-2 space-x-2 rounded-md hover:bg-gray-300 transition-pacofide"
                    >
                      {logos.dashboard}
                      <span className="pacofide-nav-dropdown-link-inner">
                        Tableau de Bord
                      </span>
                    </a>
                  </li>
                  {canDownloadFiles && (
                    <li className="pacofide-nav-dropdown-item">
                      <a
                        onClick={() => {
                          setOpenDownloads(true);
                          switchMobileMenu();
                        }}
                        className="flex flex-col items-center justify-center p-2 space-x-2 rounded-md hover:bg-gray-300 transition-pacofide"
                      >
                        {logos.database}
                        <span className="pacofide-nav-dropdown-link-inner">
                          Télécharger
                        </span>
                      </a>
                    </li>
                  )}
                  <li className="pacofide-nav-dropdown-item">
                    <a
                      onClick={() => navigateAndHide("reports")}
                      className="flex flex-col items-center justify-center p-2 space-x-2 rounded-md hover:bg-gray-300 transition-pacofide"
                    >
                      {logos.library}
                      <span className="pacofide-nav-dropdown-link-inner">
                        Documents
                      </span>
                    </a>
                  </li>
                  <li className="pacofide-nav-dropdown-item">
                    <a
                      href="#"
                      className="flex flex-col items-center justify-center p-2 space-x-2 rounded-md hover:bg-gray-300 transition-pacofide"
                      onClick={() => navigateAndHide("maplibrary/")}
                    >
                      {logos.maps}
                      <span className="pacofide-nav-dropdown-link-inner">
                        Médiathèque
                      </span>
                    </a>
                  </li>
                  <li className="pacofide-nav-dropdown-item">
                    <a
                      href="#"
                      className="flex flex-col items-center justify-center p-2 space-x-2 rounded-md hover:bg-gray-300 transition-pacofide"
                      onClick={() => navigateAndHide("actors/")}
                    >
                      {logos.actors}
                      <span className="pacofide-nav-dropdown-link-inner">Acteurs</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>

      {/* Here comes download modal */}
      <DownloadsModal
        openDownloads={openDownloads}
        setOpenDownloads={setOpenDownloads}
      />

      <div
        className={`overlay-inner absolute right-[40px] top-[150px] z-500 ${
          location.pathname == "/graph" ? "" : "hidden"
        }`}
      >
        <IndicateurAnalyseButton onClick={openAnalyse} />
      </div>
      <DashboardMenu
        isOpen={isAnalyzeOpen}
        onClose={closeAnalyse}
        selectIntervention={setSelectedIntervention}
      />
    </>
  );
}
